import React from 'react';

import { EpIconRegularAddressBook } from './variants/regular/EpIconRegularAddressBook/EpIconRegularAddressBook';
import { EpIconRegularCalendar } from './variants/regular/EpIconRegularCalendar/EpIconRegularCalendar';
import { EpIconRegularCalendarAlt } from './variants/regular/EpIconRegularCalendarAlt/EpIconRegularCalendarAlt';
import { EpIconRegularCalendarCheck } from './variants/regular/EpIconRegularCalendarCheck/EpIconRegularCalendarCheck';
import { EpIconRegularEnvelope } from './variants/regular/EpIconRegularEnvelope/EpIconRegularEnvelope';
import { EpIconRegularQuestionCircle } from './variants/regular/EpIconRegularQuestionCircle/EpIconRegularQuestionCircle';
import { EpIconSolidAddressBook } from './variants/solid/EpIconSolidAddressBook/EpIconSolidAddressBook';
import { EpIconSolidAngleDoubleLeft } from './variants/solid/EpIconSolidAngleDoubleLeft/EpIconSolidAngleDoubleLeft';
import { EpIconSolidAngleDoubleRight } from './variants/solid/EpIconSolidAngleDoubleRight/EpIconSolidAngleDoubleRight';
import { EpIconSolidAngleLeft } from './variants/solid/EpIconSolidAngleLeft/EpIconSolidAngleLeft';
import { EpIconSolidAngleRight } from './variants/solid/EpIconSolidAngleRight/EpIconSolidAngleRight';
import { EpIconSolidBacterium } from './variants/solid/EpIconSolidBacterium/EpIconSolidBacterium';
import { EpIconSolidBars } from './variants/solid/EpIconSolidBars/EpIconSolidBars';
import { EpIconSolidBookReader } from './variants/solid/EpIconSolidBookReader/EpIconSolidBookReader';
import { EpIconSolidBriefcaseMedical } from './variants/solid/EpIconSolidBriefcaseMedical/EpIconSolidBriefcaseMedical';
import { EpIconSolidCaretDown } from './variants/solid/EpIconSolidCaretDown/EpIconSolidCaretDown';
import { EpIconSolidChartBar } from './variants/solid/EpIconSolidChartBar/EpIconSolidChartBar';
import { EpIconSolidChartLine } from './variants/solid/EpIconSolidChartLine/EpIconSolidChartLine';
import { EpIconSolidChartPie } from './variants/solid/EpIconSolidChartPie/EpIconSolidChartPie';
import { EpIconSolidCheck } from './variants/solid/EpIconSolidCheck/EpIconSolidCheck';
import { EpIconSolidChevronDown } from './variants/solid/EpIconSolidChevronDown/EpIconSolidChevronDown';
import { EpIconSolidCircle } from './variants/solid/EpIconSolidCircle/EpIconSolidCircle';
import { EpIconSolidClock } from './variants/solid/EpIconSolidClock/EpIconSolidClock';
import { EpIconSolidCopy } from './variants/solid/EpIconSolidCopy/EpIconSolidCopy';
import { EpIconSolidEnvelope } from './variants/solid/EpIconSolidEnvelope/EpIconSolidEnvelope';
import { EpIconSolidEnvelopeSquare } from './variants/solid/EpIconSolidEnvelopeSquare/EpIconSolidEnvelopeSquare';
import { EpIconSolidEraser } from './variants/solid/EpIconSolidEraser/EpIconSolidEraser';
import { EpIconSolidFolderOpen } from './variants/solid/EpIconSolidFolderOpen/EpIconSolidFolderOpen';
import { EpIconSolidGlobe } from './variants/solid/EpIconSolidGlobe/EpIconSolidGlobe';
import { EpIconSolidHandHoldingMedical } from './variants/solid/EpIconSolidHandHoldingMedical/EpIconSolidHandHoldingMedical';
import { EpIconSolidHandSparkles } from './variants/solid/EpIconSolidHandSparkles/EpIconSolidHandSparkles';
import { EpIconSolidHeadphones } from './variants/solid/EpIconSolidHeadphones/EpIconSolidHeadphones';
import { EpIconSolidHospital } from './variants/solid/EpIconSolidHospital/EpIconSolidHospital';
import { EpIconSolidHospitalAlt } from './variants/solid/EpIconSolidHospitalAlt/EpIconSolidHospitalAlt';
import { EpIconSolidHouseUser } from './variants/solid/EpIconSolidHouseUser/EpIconSolidHouseUser';
import { EpIconSolidInfoCircle } from './variants/solid/EpIconSolidInfoCircle/EpIconSolidInfoCircle';
import { EpIconSolidLaptopMedical } from './variants/solid/EpIconSolidLaptopMedical/EpIconSolidLaptopMedical';
import { EpIconSolidLongArrowAltLeft } from './variants/solid/EpIconSolidLongArrowAltLeft/EpIconSolidLongArrowAltLeft';
import { EpIconSolidLongArrowAltRight } from './variants/solid/EpIconSolidLongArrowAltRight/EpIconSolidLongArrowAltRight';
import { EpIconSolidMobileAlt } from './variants/solid/EpIconSolidMobileAlt/EpIconSolidMobileAlt';
import { EpIconSolidPaperPlane } from './variants/solid/EpIconSolidPaperPlane/EpIconSolidPaperPlane';
import { EpIconSolidPencilAlt } from './variants/solid/EpIconSolidPencilAlt/EpIconSolidPencilAlt';
import { EpIconSolidPrint } from './variants/solid/EpIconSolidPrint/EpIconSolidPrint';
import { EpIconSolidQuestionCircle } from './variants/solid/EpIconSolidQuestionCircle/EpIconSolidQuestionCircle';
import { EpIconSolidSave } from './variants/solid/EpIconSolidSave/EpIconSolidSave';
import { EpIconSolidSearch } from './variants/solid/EpIconSolidSearch/EpIconSolidSearch';
import { EpIconSolidShareAlt } from './variants/solid/EpIconSolidShareAlt/EpIconSolidShareAlt';
import { EpIconSolidSignOutAlt } from './variants/solid/EpIconSolidSignOutAlt/EpIconSolidSignOutAlt';
import { EpIconSolidSitemap } from './variants/solid/EpIconSolidSitemap/EpIconSolidSitemap';
import { EpIconSolidTh } from './variants/solid/EpIconSolidTh/EpIconSolidTh';
import { EpIconSolidTimes } from './variants/solid/EpIconSolidTimes/EpIconSolidTimes';
import { EpIconSolidTransgender } from './variants/solid/EpIconSolidTransgender/EpIconSolidTransgender';
import { EpIconSolidTrashAlt } from './variants/solid/EpIconSolidTrashAlt/EpIconSolidTrashAlt';
import { EpIconSolidUser } from './variants/solid/EpIconSolidUser/EpIconSolidUser';
import { EpIconSolidUserInjured } from './variants/solid/EpIconSolidUserInjured/EpIconSolidUserInjured';
import { EpIconSolidVirus } from './variants/solid/EpIconSolidVirus/EpIconSolidVirus';
import { EpIconSolidViruses } from './variants/solid/EpIconSolidViruses/EpIconSolidViruses';
import { EpIconRegularClock } from './variants/regular/EpIconRegularClock/EpIconRegularClock';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      IconComponentTag: IEpIconVariantProps;
    }
  }
}

export interface IEpIconVariantProps {
  iconSize?: number;
  customClasses?: string;
}

export interface IEpIconProps extends IEpIconVariantProps {
  iconName: string;
}

export type IEpIconsRegularList = {
  RegularAddressBook: React.FC<IEpIconProps>;
  RegularCalendarAlt: React.FC<IEpIconProps>;
  RegularEnvelope: React.FC<IEpIconProps>;
  RegularEnvelop: React.FC<IEpIconProps>;
  RegularQuestionCircle: React.FC<IEpIconProps>;
  RegularCalendar: React.FC<IEpIconProps>;
  RegularCalendarCheck: React.FC<IEpIconProps>;
  RegularClock: React.FC<IEpIconProps>;
};

export type IEpIconsSolidList = {
  SolidChevronDown: React.FC<IEpIconProps>;
  SolidTimes: React.FC<IEpIconProps>;
  SolidCircle: React.FC<IEpIconProps>;
  SolidUser: React.FC<IEpIconProps>;
  SolidAddressBook: React.FC<IEpIconProps>;
  SolidGlobe: React.FC<IEpIconProps>;
  SolidHeadphones: React.FC<IEpIconProps>;
  SolidBookReader: React.FC<IEpIconProps>;
  SolidSignOutAlt: React.FC<IEpIconProps>;
  SolidSave: React.FC<IEpIconProps>;
  SolidCheck: React.FC<IEpIconProps>;
  SolidInfoCircle: React.FC<IEpIconProps>;
  SolidLongArrowAltRight: React.FC<IEpIconProps>;
  SolidBars: React.FC<IEpIconProps>;
  SolidHouseUser: React.FC<IEpIconProps>;
  SolidTh: React.FC<IEpIconProps>;
  SolidLaptopMedical: React.FC<IEpIconProps>;
  SolidVirus: React.FC<IEpIconProps>;
  SolidViruses: React.FC<IEpIconProps>;
  SolidBriefcaseMedical: React.FC<IEpIconProps>;
  SolidChartLine: React.FC<IEpIconProps>;
  SolidChartPie: React.FC<IEpIconProps>;
  SolidHandHoldingMedical: React.FC<IEpIconProps>;
  SolidTrashAlt: React.FC<IEpIconProps>;
  SolidFolderOpen: React.FC<IEpIconProps>;
  SolidAngleRight: React.FC<IEpIconProps>;
  SolidAngleDoubleRight: React.FC<IEpIconProps>;
  SolidAngleLeft: React.FC<IEpIconProps>;
  SolidAngleDoubleLeft: React.FC<IEpIconProps>;
  SolidClock: React.FC<IEpIconProps>;
  SolidEnvelopSquare: React.FC<IEpIconProps>;
  SolidPaperPlane: React.FC<IEpIconProps>;
  SolidLongArrowAltLeft: React.FC<IEpIconProps>;
  SolidPrint: React.FC<IEpIconProps>;
  SolidCopy: React.FC<IEpIconProps>;
  SolidUserInjured: React.FC<IEpIconProps>;
  SolidMobile: React.FC<IEpIconProps>;
  SolidPencilAlt: React.FC<IEpIconProps>;
  SolidSearch: React.FC<IEpIconProps>;
  SolidEraser: React.FC<IEpIconProps>;
  SolidEnvelop: React.FC<IEpIconProps>;
  SolidTransgender: React.FC<IEpIconProps>;
  SolidMobileAlt: React.FC<IEpIconProps>;
  SolidQuestionCircle: React.FC<IEpIconProps>;
  SolidCaretDown: React.FC<IEpIconProps>;
  SolidHandSparkles: React.FC<IEpIconProps>;
  SolidBacterium: React.FC<IEpIconProps>;
  SolidHospitalALt: React.FC<IEpIconProps>;
  SolidSitemap: React.FC<IEpIconProps>;
  SolidHospital: React.FC<IEpIconProps>;
  SolidShareAlt: React.FC<IEpIconProps>;
  SolidChartBar: React.FC<IEpIconProps>;
};

export const regularIconsList: IEpIconsRegularList = {
  RegularAddressBook: EpIconRegularAddressBook,
  RegularCalendar: EpIconRegularCalendar,
  RegularCalendarCheck: EpIconRegularCalendarCheck,
  RegularEnvelope: EpIconRegularEnvelope,
  RegularCalendarAlt: EpIconRegularCalendarAlt,
  RegularEnvelop: EpIconRegularEnvelope,
  RegularQuestionCircle: EpIconRegularQuestionCircle,
  RegularClock: EpIconRegularClock
};

export const solidIconsList: IEpIconsSolidList = {
  SolidChevronDown: EpIconSolidChevronDown,
  SolidTimes: EpIconSolidTimes,
  SolidCircle: EpIconSolidCircle,
  SolidUser: EpIconSolidUser,
  SolidAddressBook: EpIconSolidAddressBook,
  SolidGlobe: EpIconSolidGlobe,
  SolidHeadphones: EpIconSolidHeadphones,
  SolidBookReader: EpIconSolidBookReader,
  SolidSignOutAlt: EpIconSolidSignOutAlt,
  SolidSave: EpIconSolidSave,
  SolidCheck: EpIconSolidCheck,
  SolidInfoCircle: EpIconSolidInfoCircle,
  SolidLongArrowAltRight: EpIconSolidLongArrowAltRight,
  SolidBars: EpIconSolidBars,
  SolidHouseUser: EpIconSolidHouseUser,
  SolidTh: EpIconSolidTh,
  SolidLaptopMedical: EpIconSolidLaptopMedical,
  SolidVirus: EpIconSolidVirus,
  SolidViruses: EpIconSolidViruses,
  SolidBriefcaseMedical: EpIconSolidBriefcaseMedical,
  SolidChartLine: EpIconSolidChartLine,
  SolidChartPie: EpIconSolidChartPie,
  SolidHandHoldingMedical: EpIconSolidHandHoldingMedical,
  SolidTrashAlt: EpIconSolidTrashAlt,
  SolidFolderOpen: EpIconSolidFolderOpen,
  SolidAngleRight: EpIconSolidAngleRight,
  SolidAngleDoubleRight: EpIconSolidAngleDoubleRight,
  SolidAngleLeft: EpIconSolidAngleLeft,
  SolidAngleDoubleLeft: EpIconSolidAngleDoubleLeft,
  SolidClock: EpIconSolidClock,
  SolidEnvelopSquare: EpIconSolidEnvelopeSquare,
  SolidPaperPlane: EpIconSolidPaperPlane,
  SolidLongArrowAltLeft: EpIconSolidLongArrowAltLeft,
  SolidPrint: EpIconSolidPrint,
  SolidCopy: EpIconSolidCopy,
  SolidUserInjured: EpIconSolidUserInjured,
  SolidMobile: EpIconSolidMobileAlt,
  SolidPencilAlt: EpIconSolidPencilAlt,
  SolidSearch: EpIconSolidSearch,
  SolidEraser: EpIconSolidEraser,
  SolidEnvelop: EpIconSolidEnvelope,
  SolidTransgender: EpIconSolidTransgender,
  SolidMobileAlt: EpIconSolidMobileAlt,
  SolidQuestionCircle: EpIconSolidQuestionCircle,
  SolidCaretDown: EpIconSolidCaretDown,
  SolidHandSparkles: EpIconSolidHandSparkles,
  SolidBacterium: EpIconSolidBacterium,
  SolidHospitalALt: EpIconSolidHospitalAlt,
  SolidSitemap: EpIconSolidSitemap,
  SolidHospital: EpIconSolidHospital,
  SolidShareAlt: EpIconSolidShareAlt,
  SolidChartBar: EpIconSolidChartBar
};
